import { attuned_theme } from "./attuned_theme";
import { DarkTheme } from "./dark_theme";
import { LightTheme } from "./light_theme";
import { merge } from "lodash";
function readPreferredTheme() {
    var _document_documentElement_dataset;
    return ((_document_documentElement_dataset = document.documentElement.dataset) === null || _document_documentElement_dataset === void 0 ? void 0 : _document_documentElement_dataset.colorTheme) === 'dark' || document.documentElement.classList.contains('dark') ? 'dark' : 'light';
}
export function constructTheme() {
    var theme = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : attuned_theme;
    var defaultTheme = readPreferredTheme() === 'light' ? LightTheme : DarkTheme;
    return merge({}, defaultTheme, theme);
}

//# sourceMappingURL=themeFactory.js.map